import React from "react";
// react-router-dom
import { Link } from "react-router-dom";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
// styles
import styles from "./sideProfileStyle";
const useStyles = makeStyles(styles);

export default function Profile(props) {
  const classes = useStyles();
  return (
    <div className={classes.profileCard}>
      <Link to="/about" className={classes.link}>
        <img
          src={props.profileInfo.background_img}
          className={classes.profileBackImg}
          alt="profile_background_image"
        />
        <div className={classes.coverProfileBackImg}></div>
        <img
          src={props.profileInfo.img}
          className={classes.profileImg}
          alt="profileImage"
        />
        <div className={classes.profileName}>{props.profileInfo.name}</div>
        <div
          className={classes.profileMessage}
          dangerouslySetInnerHTML={{
            __html: props.profileInfo.message,
          }}
        ></div>
      </Link>
    </div>
  );
}
